import { graphql } from 'gatsby';

import t from '../../../../../libs/translate';
import { CollectionSliderWrapper } from '../../../../components/slider/collection-slider-wrapper';
import {
  ComponentProps,
  PossibleContentSections,
} from '../../fragment-and-types';
import { ContentLivePreviewConfig } from '../../live-preview/types';
import { useCollection } from './useCollection';

export const CollectionSliderFragment = graphql`
  fragment CollectionSliderFragment on STRAPI__COMPONENT_SHARED_COLLECTION_SLIDER {
    collectionUuid
    strapi_component
  }
`;

export const componentName = 'shared.collection-slider';

export type CollectionSliderData = {
  collectionUuid: string;
  strapi_component: typeof componentName;
};

export type CollectionSliderPreview = CollectionSliderData;

export const isCollectionSlider = (
  component: PossibleContentSections,
): component is CollectionSliderData => {
  return component.strapi_component === componentName;
};

export const StrapiCollectionSlider = ({
  collectionUuid,
  lang,
  locale,
  langPrefix,
}: ComponentProps<CollectionSliderData>) => {
  const { collection, translations } = useCollection(
    collectionUuid,
    lang,
    locale,
  );

  return collection !== undefined && translations !== undefined ? (
    <CollectionSliderWrapper
      collection={{ ...collection, emotionAssetId: collection.assets.emotion }}
      langPrefix={langPrefix}
      collectionLinkLabel={t(
        translations,
        'collection_slider_collection_link_label',
      )}
      detailsPageLabel={t(translations, 'show_product_details_label')}
    />
  ) : null;
};

export const config = {
  isComponent: isCollectionSlider,
  Component: StrapiCollectionSlider,
  componentName,
};

export const previewConfig: ContentLivePreviewConfig = {
  populationParams: {},
  componentName,
  mapProperties: (slider): CollectionSliderData | null =>
    slider.strapi_component === componentName ? slider : null,
};
